import {
  Component,
  AfterViewInit,
  ViewChildren,
  QueryList,
  ComponentFactoryResolver,
  Input
} from '@angular/core';
import { SelectEvent } from '@progress/kendo-angular-layout';
import { StepperDirective } from './kendo-step/stepper-host.directive';
import { IStep } from './kendo-step/stepper-step.i';

@Component({
  selector: 'ags-kendo-stepper',
  templateUrl: './kendo-stepper.component.html',
  styleUrls: ['./kendo-stepper.component.scss']
})
export class KendoStepperComponent implements AfterViewInit {
  private _stepList: IStep[] = [];

  @ViewChildren(StepperDirective) stepperHost: QueryList<StepperDirective>;
  @Input() public set stepList(val: IStep[]) {
    let tmpList = val;
    tmpList = tmpList.filter((step: IStep) => {
      if (!step.condition) return true;
      return step.condition();
    });
    tmpList.forEach((step: IStep, idx: number) => {
      step.rank = idx;
    });
    this._stepList = tmpList;
    setTimeout(() => this.generateStepComponent());
  }
  public get stepList(): IStep[] {
    return this._stepList;
  }

  public msgOpen = false;
  public msgText = '';

  constructor(private componentFactoryResolver: ComponentFactoryResolver) {}

  ngAfterViewInit() {
    this.stepperHost.changes.subscribe(() => setTimeout(() => this.generateStepComponent()));
  }

  private generateStepComponent() {
    for (let idx = 0; idx < this.stepList.length; idx++) {
      const step = this.stepList[idx];
      const stepHost = this.stepperHost.toArray()[0];

      if (!step || !stepHost || !step.active || !step.component) continue;
      const componentFactory = this.componentFactoryResolver.resolveComponentFactory(step.component);

      const viewContainerRef = stepHost.viewContainerRef;
      viewContainerRef.clear();
      const componentRef = viewContainerRef.createComponent(componentFactory);
      componentRef.instance.step = this.stepList[idx];
      componentRef.instance.validation.subscribe(($event: any) => {
        let enableChangeStep = true;
        if (this.stepList[idx].validation)
          enableChangeStep = this.stepList[idx].validation(
            idx + 1 < this.stepList.length ? this.stepList[idx + 1] : null,
            $event
          );
        if (enableChangeStep && idx + 1 < this.stepList.length) this.stepValidation(this.stepList[idx]);
      });
      componentRef.instance.backStep.subscribe(($event: any) => {
        let enableChangeStep = true;
        if (this.stepList[idx].backStep)
          enableChangeStep = this.stepList[idx].backStep(idx > 0 ? this.stepList[idx - 1] : null, $event);
        if (enableChangeStep && idx > 0) this.selectStep(this.stepList[idx - 1]);
      });
      break;
    }
  }

  public selectStep(selectedStep: IStep) {
    if (selectedStep.locked) return;
    this.stepList.forEach(step => {
      if (step.rank === selectedStep.rank) {
        step.active = true;
      } else {
        step.active = false;
      }
    });
  }

  public stepValidation(option: IStep) {
    this.stepList.forEach(step => {
      if (step.rank === option.rank + 1) {
        step.active = true;
        step.locked = false;
      } else {
        step.active = false;
      }
    });
  }

  public onTabSelect(selectEvent: SelectEvent) {
    const actStepIdx = this.stepList.findIndex(step => step.active === true);
    if (actStepIdx === -1) return;

    selectEvent.preventDefault();
    let changeStepIdx = actStepIdx;
    while (changeStepIdx !== selectEvent.index) {
      if (actStepIdx > selectEvent.index) {
        if (
          this.stepList[changeStepIdx].backStep &&
          !this.stepList[changeStepIdx].backStep(this.stepList[selectEvent.index], null)
        )
          break;
        changeStepIdx -= 1;
      } else if (actStepIdx < selectEvent.index) {
        if (
          this.stepList[changeStepIdx].validation &&
          !this.stepList[changeStepIdx].validation(this.stepList[selectEvent.index], null)
        )
          break;
        changeStepIdx += 1;
      }
    }

    if (changeStepIdx !== selectEvent.index) {
      this.msgText =
        actStepIdx > selectEvent.index
          ? 'Les conditions de retour de cette étape ne permettent pas de retourner plus en arrière.'
          : "Les conditions de validation de cette étape ne permettent pas d'avancer plus loin, veuillez valider cette étape avant de continuer.";
      this.msgOpen = true;
    }
    const selectedStep = this.stepList[changeStepIdx];
    if (selectedStep) this.selectStep(selectedStep);
  }
}
